import { DataGridPremium } from '@mui/x-data-grid-premium';
import { deDE } from '@mui/x-data-grid/locales';
import { get } from 'lodash';
import React, { FC, useMemo } from 'react';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import { KOSTEN_ARTEN, PLATZHALTER_TEXT } from '../../../../../../../lib/constants/constant';
import { DisplayEuroMUI } from '../../../../../../../utils/formats';
import { enumT } from '../../../../../../../utils/helper';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';

// import schemas
import MittelabrufSchema from '../../../../../../../lib/paths/mittelabruf_FULL_Paths.json';
import NachweisPositionsSchema from '../../../../../../../lib/paths/nachweisposition_FULL_Paths.json';
const MA_P = MittelabrufSchema.attributes;
const NP_P = NachweisPositionsSchema.attributes;

const InvestitionsKostenUebersichtMA: FC<{}> = () => {
	const { application } = useApplication();
	const columns = useMemo(() => {
		let column = [
			{ field: 'id', headerName: 'ID', width: 80, groupable: false, hide: true },
			{ field: 'unternehmen', headerName: 'Unternehmen / Institution', flex: 1, groupable: false },
			{ field: 'kostraeger', headerName: 'Kostenträger', flex: 1 },

			{ field: 'name', headerName: 'Name', flex: 1, groupable: false },
			{
				field: 'geplanteSumme',
				headerName: 'Geplante Summe',
				flex: 1,
				type: 'number' as const,
				valueFormatter: (value: any) => {
					return DisplayEuroMUI(value);
				},
			},
		];

		return column;
	}, []);

	const rows = useMemo(() => {
		let row = get(application, MA_P.Mittelabruf_Nachweispositions.path, [])
			.filter(
				(ele: any) =>
					get(ele, NP_P.Allgemein_Kostenposition.schema.attributes.Allgemein_Kostenart_Finanzierung.path) === KOSTEN_ARTEN.Investitionskosten
			)
			.map((ele: any) => {
				return {
					id: get(ele, 'id'),
					kostraeger: enumT(get(ele, NP_P.Allgemein_Kostenposition.schema.attributes.Allgemein_Kostentraeger.path, '')),
					unternehmen: get(
						ele,
						NP_P.Allgemein_Kostenposition.schema.attributes.Unternehmen.schema.attributes.Geschaeftsbezogene_Daten_Name_Der_Organisation.path
					),
					name: get(ele, NP_P.Allgemein_Bezeichnung.path),
					kostenKategorie: get(
						ele,
						NP_P.Allgemein_Kostenposition.schema.attributes.Allgemein_Kostenkategorie.schema.attributes.Allgemein_Bezeichnung.path
					),
					geplanteSumme: get(ele, NP_P.Allgemein_Ausgaben_Kosten.path, 0),
				};
			});
		return row;
	}, [application]);

	const initialState: any = useMemo(() => {
		return {
			aggregation: {
				model: {
					geplanteSumme: 'sum',
				},
			},
			rowGrouping: {
				model: ['unternehmen'],
			},
		};
	}, []);

	return (
		<>
			<ApplicationHeading title='Investitionskosten Übersicht' description={PLATZHALTER_TEXT} />
			<DataGridPremium
				rows={rows}
				columns={columns}
				initialState={initialState}
				hideFooter
				disableRowSelectionOnClick
				localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
			/>
		</>
	);
};
export default InvestitionsKostenUebersichtMA;
